import React, { useState, useMemo, useEffect } from "react";
import Modal from "./Modal";
import TimeProgress from "./TimeProgress";
import TimeMeasurements from "./TimeMeasurements";
import LifeGrid from "./LifeGrid";
import Header from "./Header";
import Footer from "./Footer";
import Quote from "./Quote.js";
import GoalTracker from "./GoalTracker.js";

const LandingPage = () => {
  const [name, setName] = useState("Aryan");
  const [birthDate, setBirthDate] = useState(new Date("2001-12-30"));
  const [weeksLeft, setWeeksLeft] = useState(0);
  const [lifeProgress, setLifeProgress] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [timeMeasurements, setTimeMeasurements] = useState({
    hours: 0,
    days: 0,
    weeks: 0,
    months: 0,
    years: 0,
    seconds: 0,
  });

  const calculateWeeksLeft = useMemo(() => {
    const endDate = new Date(birthDate);
    endDate.setFullYear(endDate.getFullYear() + 60);
    const timeDiff = endDate.getTime() - new Date().getTime();
    const weeksDiff = Math.ceil(timeDiff / (1000 * 3600 * 24 * 7));
    return weeksDiff > 0 ? weeksDiff : 0;
  }, [birthDate]);

  const calculateLifeProgress = useMemo(() => {
    const totalWeeks = 60 * 52;
    const weeksPassed = totalWeeks - weeksLeft;
    return (weeksPassed / totalWeeks) * 100;
  }, [weeksLeft]);

  useEffect(() => {
    setWeeksLeft(calculateWeeksLeft);
    setLifeProgress(calculateLifeProgress);
  }, [birthDate, calculateWeeksLeft, calculateLifeProgress]);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const endDate = new Date(birthDate);
      endDate.setFullYear(endDate.getFullYear() + 60);

      const diff = endDate - now;

      setTimeMeasurements({
        years: Math.floor(diff / (1000 * 60 * 60 * 24 * 365)),
        months: Math.floor(diff / (1000 * 60 * 60 * 24 * 30)) % 12,
        weeks: Math.floor(diff / (1000 * 60 * 60 * 24 * 7)) % 4,
        days: Math.floor(diff / (1000 * 60 * 60 * 24)) % 7,
        hours: Math.floor(diff / (1000 * 60 * 60)) % 24,
        seconds: Math.floor(diff / 1000) % 60,
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [birthDate]);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleBirthDateChange = (e) => {
    setBirthDate(new Date(e.target.value));
  };

  // Open modal function
  const openModal = () => setShowModal(true);
  // Close modal function
  const closeModal = () => setShowModal(false);

  return (
    <div className="min-h-screen bg-black text-white">
      {showModal && (
        <Modal
          name={name}
          birthDate={birthDate}
          setName={handleNameChange}
          setBirthDate={handleBirthDateChange}
          setShowModal={closeModal} // Correctly passes close function
        />
      )}

      <div className="container mx-auto px-4 py-28">
        <Header name={name} weeksLeft={weeksLeft} setShowModal={openModal} />
        <TimeProgress lifeProgress={lifeProgress} />
        <TimeMeasurements timeMeasurements={timeMeasurements} />
        <LifeGrid weeksLeft={weeksLeft} />
        <Quote />
        <GoalTracker />
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;
